import { Injectable } from "@angular/core";
import { BackendService } from "@tg4/http-infrastructure/dist/src";
import { cy } from "date-fns/locale";
import { Observable } from "rxjs";
import { ManagerEvaluationRecord } from "./_interfaces/manager-evaluation-record";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UserPreview } from "src/app/shared/interfaces/user-preview.interface";
import { map } from "rxjs/operators";
import { AuthService } from "src/app/shared/services/auth.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { ConfigService } from "src/app/shared/services/multi-clients/config.service";

@Injectable()
export class ManagerEvaluationService {
    constructor(
        private _httpService: BackendService,
        private authService: AuthService,
        private http: HttpClient,
        private _sharedService: SharedService,
        private _configService: ConfigService
    ) {}

    public getTeamListForEvaluation(cycleId: number): Observable<any> {
        return this._httpService.get("getTeamListForEvaluation", [], [{ name: "cycleId", value: cycleId as any }]);
    }

    public getHasReviewAccess(userId: string): Observable<any> {
        return this._httpService.get("hasAccessToReview", [], [{ name: "userId", value: userId as any }]);
    }

    public getTeamComparisonExcel(cycleId: number, onlyCommentsColumns: boolean = false, userId: string = ""): Observable<any> {
        const user = this.authService.getLoggedUser();
        const options = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Authorization: user.access_token,
                Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            observe: "response" as "body",
            responseType: "blob" as "json",
        };

        const impersonatedUser: UserPreview | null = this.authService.getImpersonatedUser();
        if (impersonatedUser && impersonatedUser.userId) {
            options.headers["UserIdToImpersonate"] = impersonatedUser.userId;
        }

        return this._httpService
            .get(
                "getManagerComparisionBook",
                [],
                [
                    { name: "cycleId", value: cycleId as any },
                    { name: "onlyCommentsColumns", value: onlyCommentsColumns as any },
                    { name: "userId", value: userId },
                ],
                null,
                null,
                options,
            )
            .pipe(map((res) => this._sharedService.downloadFile(res)));
    }

    public getTeamUserForEvaluation(cycleId: number, userId: string): Observable<any> {
        return this._httpService.get(
            "getTeamUserForEvaluation",
            [],
            [
                { name: "cycleId", value: cycleId as any },
                { name: "userId", value: userId },
            ],
        );
    }

    public saveManagerEvaluation(evaluation: ManagerEvaluationRecord): Observable<any> {
        return this._httpService.post("saveManagerEvaluation", evaluation);
    }

    public sendManagerEvaluation(evaluation: ManagerEvaluationRecord): Observable<any> {
        return this._httpService.post("sendManagerEvaluation", evaluation);
    }

    public get360EvaluationResults(cycleId: number, userId: string, getManagerEvaluation: boolean = false): Observable<any> {
        return this._httpService.get(
            "get360EvaluationResults",
            [],
            [
                { name: "cycleId", value: cycleId as any },
                { name: "userId", value: userId },
                { name: "getManagerEvaluation", value: getManagerEvaluation },
            ],
        );
    }

    public getUserSummary(cycleParticipantId: number, cycleId: number, selectedLanguage: string, oneCycle: boolean = false): Observable<any> {
        return this._httpService.get(
            "getCalibrationUserSummary",
            [],
            [
                { name: "cycleParticipantId", value: cycleParticipantId as any },
                { name: "cycleId", value: cycleId as any },
                { name: "selectedLanguage", value: selectedLanguage as any },
                { name: "oneCycle", value: oneCycle as any },
            ],
        );
    }

    public sendLastDayEmail(cycleId: number, forceSend: boolean, validate: boolean = false): Observable<any> {
        return this._httpService.post("sendManagerEvaluationLastDay", {
            cycleId: cycleId,
            forceSend: forceSend,
            validate: validate,
        });
    }

    public reopenManagerEvaluation(cycleParticipantId: number, userId: string): Observable<any> {
        return this._httpService.put("reopenManagerEvaluation", {
            cycleId: cycleParticipantId,
            subjectUserId: userId,
        });
    }

    public getPreviousEvaluations(cycleId: number, userId: string): Observable<any> {
        return this._httpService.get(
            "getPreviousEvaluations",
            [],
            [
                { name: "cycleId", value: cycleId as any },
                { name: "userId", value: userId },
            ],
        );
    }

    // Funcionalidade desabilitada

    // public deleteManagerEvaluation(
    //   cycleParticipantId: number,
    //   userId: string
    // ): Observable<any> {
    //   return this._httpService.delete('deleteManagerEvaluation', [
    //     { 'name': 'cycleId', 'value': cycleParticipantId as any },
    //     { 'name': 'subjectUserId', 'value': userId }
    //   ]);
    // }

    // public getManagerEvaluationToDelete(
    //   cycleId: number,
    //   userId: string
    // ): Observable<any> {
    //   return this._httpService.get('getManagerEvaluationToDelete', [], [
    //     { 'name': 'cycleId', 'value': cycleId as any },
    //     { 'name': 'subjectUserId', 'value': userId }
    //   ]);
    // }
}
